<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-role-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-action-bar
          :showDeleted="false"
          v-on:update:search="searchQuery = $event"
          v-on:update:deleted="showDeleted = $event"
          title="Roles"
      >
        <vs-dropdown-item>
          <span
              v-if="canAccessRoute('role.create')"
              class="flex items-center"
              @click="$router.push({ name: 'role.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Role</span>
          </span>
        </vs-dropdown-item>
      </grid-action-bar>

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="xl"
          :data="data"
          :loading="loading"
          :auto-size="true"
          :search="searchQuery"
          @rowClicked="onRowClicked"
      >
      </t-grid>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import router from '../../../router';

export default {
  components: {
    GridActionBar,
    TGrid,
    vSelect,
    YesNoToggle,
    // Cell Renderer
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,

      // AgGrid
      columnDefs: [
        {
          headerName: 'Role',
          field: 'RoleName',
          width: 310,
          maxWidth: 350,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Application',
          field: 'applications',
          filter: 'agTextColumnFilter',
          width: 300,
          valueGetter: ({ data }) => {
              const { applications } = data;

              if (applications.length === 0) {
                return '';
              }

              return applications[0].ApplicationName;
          },
        },
      ],
      // Cell Renderer Components
      data: [],
      loading: false,
    }
  },
  watch: {
    showDeleted(value) {
      this.list({IsDeleted: value | 0});
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  mounted() {
    this.list();
  },
  methods: {
    updateSearchQuery (val) {
      this.searchQuery = val;
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.statusFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    async onRowClicked({data}) {
      const route = 'role.view';

      if (await this.canAccessRoute(route, false)) {
        this.$router.push({ name: route, params: { id: data.id }}).catch(() => {});
      }
    },
    async list(params = {}) {
      try {
        this.loading = true;
        const { data } = await this.$api.roles.all({ params });
        this.data = data.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
}

</script>

<style lang="scss">
#page-company-list {
  .company-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
